import React from 'react';
import styles from '../styles/Design_Lab.module.css';

export default function GalleryCard({ pin, index, total }) {
  return (
    <article className={styles.projectCard}>
      <div className={styles.projectMeta}>
        <span>
          {String(index + 1).padStart(2, '0')}/
          {String(total).padStart(2, '0')}
        </span>

        <span className={styles.projectCategory}>{pin.category}</span>
      </div>

      <div className={styles.projectImageWrap}>
        <img
          src={pin.image}
          alt={pin.title}
          className={styles.projectImage}
          loading="lazy"
        />
      </div>

      <div className={styles.projectContent}>
        <h2 className={styles.projectTitle}>{pin.title}</h2>

        <p className={styles.projectSummary}>{pin.summary}</p>

        <div className={styles.projectDetails}>
          <div className={styles.detailsRow}>
            <span className={styles.detailsLabel}>Category</span>
            <span className={styles.detailsValue}>{pin.category}</span>
          </div>

          <div className={styles.detailsRow}>
            <span className={styles.detailsLabel}>Services</span>
            <span className={styles.detailsValue}>
              {pin.services.join(', ')}
            </span>
          </div>

          <div className={styles.detailsRow}>
            <span className={styles.detailsLabel}>Year</span>
            <span className={styles.detailsValue}>{pin.year}</span>
          </div>
        </div>

        {pin.website && (
          <a
            href={pin.website}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.projectButton}
          >
            View Live Site
          </a>
        )}
      </div>
    </article>
  );
}